import { render, staticRenderFns } from "./OTPVerificationPrompt.vue?vue&type=template&id=ab526ed0"
import script from "./OTPVerificationPrompt.vue?vue&type=script&lang=js"
export * from "./OTPVerificationPrompt.vue?vue&type=script&lang=js"
import style0 from "./OTPVerificationPrompt.vue?vue&type=style&index=0&id=ab526ed0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports